module.exports = __webpack_public_path__ + "img/levelvert.2c746061.svg";